import storage from './storage';

const KEY = 'crm_custom_fields';

export const FIELD_TYPES = [
  { id: 'string', label: 'Text' },
  { id: 'number', label: 'Zahl' },
  { id: 'date',   label: 'Datum' },
  { id: 'url',    label: 'Link/URL' },
];

export function loadCustomFields() {
  return storage.get(KEY, []);
}

export function saveCustomFields(fields) {
  storage.set(KEY, fields);
}

export function addCustomField(field) {
  const fields = loadCustomFields();
  const newField = {
    id: 'cf_' + Date.now(),
    label: field.label,
    type: field.type || 'string',
    custom: true,
  };
  saveCustomFields([...fields, newField]);
  return newField;
}

export function deleteCustomField(id) {
  saveCustomFields(loadCustomFields().filter(f => f.id !== id));
}

export function updateCustomField(id, changes) {
  saveCustomFields(loadCustomFields().map(f => f.id === id ? { ...f, ...changes } : f));
}
